import { Staff } from "module/auth/types";

export const filterStaffVisibleOnList = (staff: Staff): boolean =>
  staff.visibleOnList;
